import { render } from "./Modifiers.vue?vue&type=template&id=0f291d56&scoped=true"
import script from "./Modifiers.vue?vue&type=script&lang=js"
export * from "./Modifiers.vue?vue&type=script&lang=js"

import "./Modifiers.vue?vue&type=style&index=0&id=0f291d56&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f291d56"]])

export default __exports__